export enum LocalTokens {
    LOGIN_INFO = "U53r_!nfO"
}